// extracted by mini-css-extract-plugin
export default {"wrapper":"CallAnalyticsActiveFilterChip_wrapper__9C8Qg","chip":"CallAnalyticsActiveFilterChip_chip__bkULG"};